import { Dispatch } from "../../controller";
import { Galeria } from "../../data.types";
import { Model,StateProps } from "../../model";

export type { Galeria } from "../../data.types";

export interface GaleriaState extends StateProps<Galeria> {
 
}

export interface GaleriaActions extends Dispatch<Galeria> {

}

const model = new Model<Galeria,GaleriaState>("galeria");

const intialValueGaleria:Galeria = {
    ...model.getInitialValue(),
    type:"galeria",
    _attachments: {
        "any": {
            content_type: "",
            data: "",
            tipo: "img",
            descricao: ""
        }
    }
}

export const initialValueGaleriaState:GaleriaState = {
    ...model.getInititalValueState(),
    row:intialValueGaleria,
}


